import { render, staticRenderFns } from "./premium-coverage.vue?vue&type=template&id=0d7d06e4&scoped=true&"
import script from "./premium-coverage.vue?vue&type=script&lang=js&"
export * from "./premium-coverage.vue?vue&type=script&lang=js&"
import style0 from "./premium-coverage.vue?vue&type=style&index=0&id=0d7d06e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7d06e4",
  null
  
)

export default component.exports